// import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { OneClickTrading } from '../../../api/request/dashboard/dashboard';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { setAmountForSymbol } from '../../../store/Slices/amountSlice';

const AskSell = ({ symbolId, digits }) => {
    const dispatch = useDispatch()
    const symbol = useSelector(state => state.updateSymbol.symbols?.[symbolId])
    const { accountId } = useSelector(state => state.accountSummary)
    const symbolParameterData = useSelector((state) => state?.symbol?.allSymbolParams?.[symbolId], shallowEqual);
    const amount = useSelector((state) =>
        state?.amount?.[symbolId] ?? symbolParameterData?.minimumAmountPerDeal ?? 0.01
    )
    const { t } = useTranslation()
    // const symbol = {};
    const sellPosition = async () => {
        const minAmount = symbolParameterData?.minimumAmountPerDeal ?? 1;
        const maxAmount = symbolParameterData?.maximumAmountPerDeal ?? 100;
        const ratio = amount / minAmount;
        const isMultiple = Math.abs(ratio - Math.round(ratio)) < 1e-8;
        if (amount < minAmount || amount > maxAmount) {
            toast.error(`Invalid Amount`);
            setTimeout(() => {
                dispatch(setAmountForSymbol({ symbolId, amount: minAmount }));
            }, 1000);

            return;
        }
        if (!isMultiple) {
            toast.error(`Amount must be a multiple of ${minAmount}`);
            setTimeout(() => {
                dispatch(setAmountForSymbol({ symbolId, amount: minAmount }));
            }, 1000);

            return;
        }
        try {
            const payload = {
                accountId: Number(accountId),
                side: 1,
                amount,
                symbolId,
                comment: "One-click trading",
            };
            const { data } = await OneClickTrading(payload);

        } catch (error) {
            toast.error(error?.response?.data?.message || "Trade execution error");
        }
    }
    return (
        <div className={`border ${symbol?.askColor == "up" ? "border-green" : symbol?.askColor == "down" && "border-red"} flex justify-between`} onClick={(e) => { e.stopPropagation(); }} onDoubleClick={(e) => { e.stopPropagation(); }}>
            <span className={`text-center px-2 flex items-center justify-center ${symbol?.askColor == "up" ? "green" : symbol?.askColor == "down" && "red"}`}>{symbol?.ask ? (symbol?.ask).toFixed(digits) : '0.00'}</span>
            <span className={`${symbol?.askColor == "up" ? "bgGreen" : symbol?.askColor == "down" && "bgRed"} bgbuySell text-white px-2 flex justify-center items-center cursor-pointer `} onClick={sellPosition}>{t("buy")}</span>
        </div>
    )
}

export default AskSell